import { serverFetch } from "@core/server";

export function fetchDocExpList({
  dateMode = 0,
  dateBeg,
  dateEnd,
  hideCancelled = true,
  idStatus,
  vidPutevki,
  pay,
  idBranch,
  q,
  sortBy,
  sortDir,
  skip = 0,
  take = 50
} = {}) {
  return serverFetch("doc-exp", {
    queryParams: {
      dateMode,
      hideCancelled,
      skip,
      take,
      ...(dateBeg ? { dateBeg } : {}),
      ...(dateEnd ? { dateEnd } : {}),
      ...(idStatus === 0 || idStatus ? { idStatus } : {}),
      ...(vidPutevki ? { vidPutevki } : {}),
      ...(pay === "unpaid" ? { unpaidOnly: true } : {}),
      ...(pay === "paid" ? { paidOnly: true } : {}),
      ...(idBranch ? { idBranch } : {}),
      ...(q ? { q } : {}),
      ...(sortBy ? { sortBy } : {}),
      ...(sortDir ? { sortDir } : {})
    }
  });
}

export function fetchDocExp(id) {
  return serverFetch(`doc-exp/${id}`);
}

export function fetchDocExpPlacements(id) {
  return serverFetch(`doc-exp/${id}/placements`);
}

export function fetchDocExpPayments(id) {
  return serverFetch(`doc-exp/${id}/payments`);
}

export function fetchDocExpLookups() {
  return serverFetch("doc-exp/lookups");
}

export function createDocExp(bodyData) {
  return serverFetch("doc-exp", { method: "POST", bodyData });
}

export function saveDocExp(bodyData) {
  return serverFetch("doc-exp", { method: "PUT", bodyData });
}

export function deleteDocExp(id) {
  return serverFetch(`doc-exp/${id}`, { method: "DELETE" });
}

export function docExpConfirm(id) {
  return serverFetch(`doc-exp/${id}/confirm`, { method: "POST", bodyData: {} });
}

export function docExpUnconfirm(id) {
  return serverFetch(`doc-exp/${id}/unconfirm`, { method: "POST", bodyData: {} });
}

export function docExpCheckIn(id, dateFact) {
  return serverFetch(`doc-exp/${id}/check-in`, {
    method: "POST",
    bodyData: dateFact ? { dateFact } : {}
  });
}

export function docExpCheckInMany(ids, dateFact) {
  return serverFetch("doc-exp/check-in", {
    method: "POST",
    bodyData: { ids, ...(dateFact ? { dateFact } : {}) }
  });
}

export function docExpUncheckIn(id) {
  return serverFetch(`doc-exp/${id}/uncheck-in`, { method: "POST", bodyData: {} });
}

export function docExpCheckOut(id, dateFact) {
  return serverFetch(`doc-exp/${id}/check-out`, {
    method: "POST",
    bodyData: dateFact ? { dateFact } : {}
  });
}

export function docExpCheckOutMany(ids, dateFact) {
  return serverFetch("doc-exp/check-out", {
    method: "POST",
    bodyData: { ids, ...(dateFact ? { dateFact } : {}) }
  });
}

export function docExpUncheckOut(id) {
  return serverFetch(`doc-exp/${id}/uncheck-out`, { method: "POST", bodyData: {} });
}

export function docExpCancel(id) {
  return serverFetch(`doc-exp/${id}/cancel`, { method: "POST", bodyData: {} });
}

export function docExpFetchDoctorVisitOptions(id, idStr, { date, idZal } = {}) {
  return serverFetch(`doc-exp/${id}/clients/${idStr}/doctor-visit-options`, {
    queryParams: {
      ...(date ? { date } : {}),
      ...(idZal ? { idZal } : {})
    }
  });
}

export function docExpSendClientToDoctor(id, idStr, bodyData) {
  return serverFetch(`doc-exp/${id}/clients/${idStr}/send-to-doctor`, {
    method: "POST",
    bodyData
  });
}

export function docExpBook(id, bodyData) {
  return serverFetch(`doc-exp/${id}/book`, { method: "POST", bodyData });
}

export function docExpClearPlacement(id) {
  return serverFetch(`doc-exp/${id}/clear-placement`, { method: "POST", bodyData: {} });
}

export function docExpRecalculate(id) {
  return serverFetch(`doc-exp/${id}/recalculate`, { method: "POST", bodyData: {} });
}

export function fetchDocExpRecalculateCheck(id) {
  return serverFetch(`doc-exp/${id}/recalculate-check`);
}

export function docExpChangeNumber(id, bodyData) {
  return serverFetch(`doc-exp/${id}/change-number`, { method: "POST", bodyData });
}

export function docExpMovePlacement(id, bodyData) {
  return serverFetch(`doc-exp/${id}/move-placement`, { method: "POST", bodyData });
}

export function docExpSellBook(bodyData) {
  return serverFetch("doc-exp/sell-book", { method: "POST", bodyData });
}

export function docExpSellBookGroup(bookings) {
  return serverFetch("doc-exp/sell-book/group", { method: "POST", bodyData: { bookings } });
}

export function docExpSellBookPreview(bodyData, signal) {
  return serverFetch("doc-exp/sell-book/preview", { method: "POST", bodyData }, signal);
}

export function fetchDocExpPayPreview(id) {
  return serverFetch(`doc-exp/${id}/pay-preview`);
}

export function docExpPayAdvance(id, bodyData) {
  return serverFetch(`doc-exp/${id}/pay-advance`, { method: "POST", bodyData });
}

export function docExpPayLines(id, bodyData) {
  return serverFetch(`doc-exp/${id}/pay-lines`, { method: "POST", bodyData });
}

export function docExpPaySettle(id, bodyData) {
  return serverFetch(`doc-exp/${id}/pay-settle`, { method: "POST", bodyData });
}

export function docExpPayReturn(id, bodyData) {
  return serverFetch(`doc-exp/${id}/pay-return`, { method: "POST", bodyData });
}

export function fetchBronGrid({ dateBeg, dateEnd, idBranch, idNumberCat, idUpper } = {}) {
  const cats = Array.isArray(idNumberCat)
    ? idNumberCat.filter((x) => x > 0)
    : idNumberCat
      ? [idNumberCat]
      : [];
  return serverFetch("bron/grid", {
    queryParams: {
      dateBeg,
      dateEnd,
      ...(idBranch ? { idBranch } : {}),
      ...(cats.length ? { idNumberCat: cats } : {}),
      ...(idUpper ? { idUpper } : {})
    }
  });
}

export function fetchBronFreeMest({ idNumber, dateBeg, dateEnd, exceptDoc } = {}) {
  return serverFetch("bron/free-mest", {
    queryParams: {
      idNumber,
      dateBeg,
      dateEnd,
      ...(exceptDoc ? { exceptDoc } : {})
    }
  });
}

export function fetchBronFreeNumbers({ dateBeg, dateEnd, exceptDoc, cntMest } = {}, signal) {
  return serverFetch(
    "bron/free-numbers",
    {
      queryParams: {
        dateBeg,
        dateEnd,
        ...(exceptDoc ? { exceptDoc } : {}),
        ...(cntMest ? { cntMest } : {})
      }
    },
    signal
  );
}

export function fetchBronFreeCategories({ dateBeg, dateEnd, cntMest = 1 } = {}, signal) {
  return serverFetch(
    "bron/free-categories",
    {
      queryParams: {
        dateBeg,
        dateEnd,
        cntMest
      }
    },
    signal
  );
}

export function fetchDocExpClientCard(idDoc, idStr) {
  return serverFetch(`doc-exp/${idDoc}/clients/${idStr}/card`);
}

export function lookupDocExpClientCard(idDoc, idStr, key) {
  return serverFetch(`doc-exp/${idDoc}/clients/${idStr}/card/lookup`, {
    queryParams: { key }
  });
}

export function assignDocExpClientCard(idDoc, idStr, bodyData) {
  return serverFetch(`doc-exp/${idDoc}/clients/${idStr}/card`, {
    method: "PUT",
    bodyData
  });
}

export function revokeDocExpClientCard(idDoc, idStr) {
  return serverFetch(`doc-exp/${idDoc}/clients/${idStr}/card`, {
    method: "DELETE"
  });
}
